// Importing necessary hooks and functions from React and Firebase
import React, { createContext, useState, useEffect } from 'react';
import { auth, db } from '../auth/firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';

// Creating a context named TenantContext to share tenant-related data
export const TenantContext = createContext();

// Provider component that supplies the tenant ID to components that need it
export const TenantProvider = ({ children }) => {
  // State to store the tenant ID for the currently signed-in user
  const [tenantId, setTenantId] = useState(null);

  // useEffect hook to fetch and set the tenant ID when the component mounts
  useEffect(() => {
    // Async function to fetch tenant ID from Firestore
    const fetchTenantId = async () => {
      const user = auth.currentUser; // Get the currently signed-in user
      if (user) {
        // Fetch the user's document from Firestore using their UID
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          setTenantId(userDoc.data().tenantId); // Set tenantId from Firestore data
        }
      }
    };

    fetchTenantId(); // Call the function to fetch tenant ID on component mount
  }, []);

  return (
    // Providing the tenantId state to any component that consumes TenantContext
    <TenantContext.Provider value={{ tenantId }}>
      {children} {/* Rendering children components within the provider */}
    </TenantContext.Provider>
  );
};
